import { LoadState, LoadStateInitialValue } from 'app/core/interfaces/generic.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';

export const INITIAL_STATE_AUTHORIZATION = new LoadStateInitialValue<AuthorizationMatrix>({
  ACCESS: {
    ORDERS: false,
    FLOWS: false,
    CALENDAR: false,
    INVOICES: false,
    STOCK: false,
    BLANK_RECEIPT: false,
    EMAIL_ACTORS: false,
    REPORTS: false,
  },
  FLOW: {
    QUERY: false,
    GET: false,
    CREATE: false,
    UPDATE: false,
    CANCEL: false,
    ACCEPT: false,
    OVERRULE_MAX: false,
    MULTI_ACCEPT: true,
  },
  INVOICES: {
    ACCESS: false,
    QUERY: false,
    LIST_INVOICES_AS_DOCUMENT: false,
    GET_INVOICE_DOCUMENT: false,
  },
  ORDER: {
    QUERY: false,
    GET: false,
    CREATE: false,
    CREATE_CCR: false,
    UPDATE: false,
    CANCEL: false,
    ACCEPT: false,
    QUERY_TEMPLATE: false,
    GET_TEMPLATE: false,
    CREATE_TEMPLATE: false,
    DELETE_TEMPLATE: false,
    GET_DELIVERY_DATES: false,
    CHECK_PALLET_FLOOR_QUANTITY: false,
    LIST_ORDERS_AS_DOCUMENT: false,
    OVERRULE_MAX: false,
  },
  STOCK: {
    GET_CURRENT_STOCK_LIST: false,
    CREATE: false,
    GET: false,
    QUERY: false,
  },
});
